<template>
  <div :class="['group-slide-down', slideDown ? 'slide-open' : 'no-slide']" v-click-out="closeDropDown">
    <div v-if="!sectionOpen" class="group-name-list">
      <group-names :groups="groupsWithSelected" @setSelectedItem="setSelectedItem"></group-names>
    </div>

    <div :class="['group', {['slide-open']: slideDown}]">
      <group v-for="group in groupsWithSelected"
             :campaignType="campaignType"
             :isGroupsSelected="isGroupsSelected"
             :group="group"
             :key="group.id"
             :isOpen="group.id === openGroupItem"
             :isUpdating="isUpdating"
             :selectedDateRange="selectedDateRange"
             :selectedGroups="group.selectedItems"
             :selectedMerchantSegmentIds="selectedMerchantSegmentIds"
             :selectedTags="selectedTags"
             :showCount="showCount"
             :showDateRangePicker="isCampaign && subConfigsGroupNames && subConfigsGroupNames.includes(group.name)"
             :subConfigDate="subConfigsGroupNames && subConfigsGroupNames.includes(group.name) ? subConfigDate : null"
             :widgetIsOpen="sectionOpen"
             @setSelectedDateRange="setSelectedDateRange"
             @setSelected="setSelectedGroups"
             @updateGroups="updateSelectedGroups"
             @updatePrimaryLocation="updatePrimaryLocation">

        <div slot="groupHeader" class="group-items-header">
          <div class="back-group-widget" @click="clickBack">
            <div class="back-link"><span class="back-text">back</span></div>
          </div>

          <modal
              wrapperClasses="prompt-modal"
              :showClose=true
              v-if="showModal"
              @close="closeModal">
            <div slot="body" class="body">
              <p>your primary location setting is currently set to</p>
              <b>{{primaryLocation}}</b>
              <p>please contact your account manager to change this setting</p>
            </div>
          </modal>
          <span :class="{ 'primary-location' : group.name === 'primary location'}" class="group-name-header">{{group.name.replace(/\_/, ' ')}}</span>
          <sup v-if="group.name === 'primary location'" class="prompt" @click="openModal">i</sup>
        </div>

      </group>
    </div>
  </div>
</template>

<script>
  import Group from './Group'
  import GroupNames from './GroupNames'
  import Modal from '../shared/Modal'

  export default {
    props: {
      campaignType: String,
      isCampaign: Boolean,
      isUpdating: Boolean,
      groupsWithSelected: Array,
      openGroupItem: [Number, String],
      sectionOpen: Boolean,
      selectedDateRange: String,
      selectedMerchantSegmentIds: Array,
      selectedTags: [Array, Object],
      showCount: Boolean,
      slideDown: Boolean,
      subConfigDate: String,
      subConfigsGroupNames: Array,
    },

    name: 'GroupsDropDown',

    components: {
      Group,
      GroupNames,
      Modal
    },

    data() {
      return {
        showModal: false,
        primaryLocation: null
      }
    },

    methods: {
      clickBack(event) {
        event.stopPropagation()
        this.$emit('closeSelectedGroup')
      },

      openModal()  {
        this.showModal = true
      },

      closeModal() {
        event.stopPropagation()
        this.showModal = false
      },

      closeDropDown(event) {
        this.$emit('closeDropDown', event)
      },

      setSelectedDateRange(dateRange) {
        this.$emit('setSelectedDateRange', dateRange)
      },

      setSelectedItem(item) {
        event.stopPropagation()
        this.$emit('setSelectedItem', item)
      },

      setSelectedGroups(groupId, selectedItems) {
        this.$emit('setSelected', groupId, selectedItems)
      },

      updateSelectedGroups(dataToUpdate) {
        this.$emit('updateSelectedGroups', dataToUpdate)
      },

      updatePrimaryLocation(context) {
        this.primaryLocation = context
      }
    },

    mounted() {
      const view = this
      document.body.addEventListener('keydown', event => { if (event.keyCode === 27) { view.closeDropDown(event) } })
    },

    beforeDestroy() {
      document.body.removeEventListener('keydown', this.closeDropDown)
    },

    computed: {
      isGroupsSelected: function() {
        return this.groupsWithSelected ? this.groupsWithSelected.filter((group) => !!group.display_names).length > 0 : false
      }
    },

    directives: {
      clickOut: {
        // from https://jsfiddle.net/bq8m4fhe/
        bind: function(el, binding, vnode) {
          el.clickOutsideEvent = function(event) {
            const isClickOutside = event.target !== el && !el.contains(event.target)
            if (isClickOutside) { vnode.context[binding.expression](event, el.id) }
          }
          document.body.addEventListener("click", el.clickOutsideEvent)
          document.body.addEventListener("touchstart", el.clickOutsideEvent)
        },
        unbind: function(el) {
          document.body.removeEventListener("click", el.clickOutsideEvent);
          document.body.removeEventListener("touchstart", el.clickOutsideEvent);
        },
        stopProp(event) {
          event.stopPropagation();
        }
      }
    },
  }
</script>
